import { lazy, Suspense, useState } from "react";
import { Loader2 } from "lucide-react";
import { Outlet } from "react-router-dom";
import { ChatSocketProvider } from "@/context/ChatSocket";
import { cn } from "@/lib/utils";

const AssistantWidget = lazy(() => import("@/components/assistant/AssistantWidget").then((m) => ({ default: m.AssistantWidget })));
import { MobileTopbar } from "./MobileTopbar";
import { Sidebar } from "./Sidebar";

export const AppShell = () => {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("usocial-sidebar") === "closed");
  const toggle = () => {
    setCollapsed((c) => {
      localStorage.setItem("usocial-sidebar", c ? "open" : "closed");
      return !c;
    });
  };
  return (
    <ChatSocketProvider>
    <div className="min-h-screen bg-background" data-testid="app-shell">
      <Sidebar collapsed={collapsed} onToggle={toggle} />
      <MobileTopbar />
      <main className={cn("transition-[padding] duration-300 ease-out", collapsed ? "md:pl-[76px]" : "md:pl-[260px]", "print:!pl-0")}>
        <div className="mx-auto max-w-[1600px] px-4 py-6 sm:px-6 md:px-10 md:py-10">
          <Suspense fallback={<div className="flex justify-center py-24" data-testid="page-loading"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>}>
            <Outlet />
          </Suspense>
        </div>
      </main>
      <Suspense fallback={null}><AssistantWidget /></Suspense>
    </div>
    </ChatSocketProvider>
  );
};
